import { RouterProvider } from "react-router-dom";
import "./App.css";

import { createBrowserRouter } from "react-router-dom";

import Products from "./components/Products/Products";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Friends from "./components/Friends/Friends";
import Main from "./Layout/Main";
import FriendDetail from "./components/FriendDetail/FriendDetail";
import Post from "./components/Post/Post";
import PostDetail from "./components/PostDetail/PostDetail";
import ProductDetail from "./components/ProductDetail/ProductDetail";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main></Main>,
      children: [
        {
          path: "/",
          element: <Home></Home>,
        },
        {
          path: "home",
          element: <Home></Home>,
        },
        {
          path: "products",
          loader: async () => {
            return fetch ('https://restcountries.com/v2/all')
          },
          element: <Products></Products>,
        },
        {
          path: "friends",
          loader: async () =>
            fetch(`https://jsonplaceholder.typicode.com/users`),
          element: <Friends></Friends>,
        },
        {
          path: "about",
          element: <About></About>,
        },
        {
          path: "friends/:friendId",
          loader: async ({ params }) => {
            return fetch(
              `https://jsonplaceholder.typicode.com/users/${params.friendId}`
            );
          },
          element: <FriendDetail></FriendDetail>,
        },
        {
          path: "*",
          element: <div>404 this route not found</div>,
        },
        {
          path: 'post',
          loader: async () => {
            return fetch ('https://jsonplaceholder.typicode.com/posts')
          },
          element: <Post></Post>
        }, 
        {
          path: 'post/:postId',
          loader: async ({params}) => {
            return fetch (`https://jsonplaceholder.typicode.com/posts/${params.postId}`)
          },
          element: <PostDetail></PostDetail>
        },
        {
          path: 'products/:name',
          loader: async ({params}) => {
            return fetch (`https://restcountries.com/v2/name/${params.name}`)
          },
          element: <ProductDetail></ProductDetail>
        }
      ],
    },
  ]);

  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
